import React, { Component } from 'react';
import {
    Card,
    Button,
    Typography,
    List,
    Calendar,
    Col,
    Row,
    Empty,
} from 'antd';
import AdminAddHolidayModal from '../../components/modals/AdminAddHolidayModal';
import AdminDeleteHolidayModal from '../../components/modals/AdminDeleteHolidayModal';
import { withManageHolidayProvider } from '../providers/ManageHolidayDataProvider';
import { convertTimestampToMoment } from '../../utils';


const { Paragraph } = Typography;

class ManageHoliday extends Component {
    state = {
        showAddModal: false,
        showDeleteModal: false,
        activeDoc: null,
    };

    showAddModal = () => {
        this.setState({ showAddModal: true });
    }

    showDeleteModal = activeDoc => e => {
        e.preventDefault();

        this.setState({ activeDoc, showDeleteModal: true });
    }

    closeAddModal = e => {
        this.setState({ showAddModal: false });

        this.props.fetchHoliday();
    }

    closeDeleteModal = () => {
        this.setState({ showDeleteModal: false });

        this.props.fetchHoliday();
    }

    renderItem = item => {
        const momentObj = convertTimestampToMoment(item.date_time);

        return (
            <List.Item
                key={item.id}
                actions={[
                    <a href="#" onClick={this.showDeleteModal(item)}>
                        delete
                    </a>
                ]}
            >
                { momentObj.format('dddd, MMMM Do YYYY') }
            </List.Item>
        );
    }

    renderList = () => {
        const { dates, isLoading } = this.props;

        if (isLoading) {
            return <List loading={isLoading} />;
        }

        if (!dates.length) {
            return <Empty />;
        }

        return (
            <List
                loading={isLoading}
                itemLayout="horizontal"
                dataSource={dates}
                renderItem={this.renderItem}
            />
        );
    }

    render() {
        const { showAddModal, showDeleteModal, activeDoc } = this.state;

        return (
            <>
                <Card 
                    title="Manage Holiday"
                    extra={
                        <Button onClick={this.showAddModal} type="primary" icon="plus">
                            Add Holiday
                        </Button>
                    }
                >
                    <Row gutter={40}>
                        <Col span={8}>
                            <Paragraph strong>
                                Calendar:
                            </Paragraph>
                            <div style={{ border: '1px solid #d9d9d9', borderRadius: 4 }}>
                                <Calendar fullscreen={false} />
                            </div>
                        </Col>
                        <Col span={16}>
                            <Paragraph strong>
                                Your booked holiday dates:
                            </Paragraph>
                            { this.renderList() }
                        </Col>
                    </Row>
                </Card>
                <AdminAddHolidayModal
                    visible={showAddModal}
                    handleClose={this.closeAddModal}
                />
                <AdminDeleteHolidayModal
                    visible={showDeleteModal}
                    handleClose={this.closeDeleteModal}
                    doc={activeDoc}
                />
            </>
        );
    }
}

export default withManageHolidayProvider(ManageHoliday);
